import { InputHTMLAttributes } from "react";

export interface IInputPops extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  styles?: string;
  checked?: boolean;
  dataTyp?: string;
  updateAble?: string;
}

export default function Radio({
  label,
  name,
  id,
  styles,
  checked,
  dataTyp = "C",
  updateAble = "false",
  ...res
}: IInputPops) {
  return (
    <>
      <input
        type={"radio"}
        name={name}
        id={id + "-" + name}
        className={styles}
        data-value={id}
        data-type={dataTyp.toString()}
        defaultChecked={checked}
        {...res}
      />
      <label
        htmlFor={id + "-" + name}
        data-update={updateAble}
        onClick={(e) => {
          const { update } = e.currentTarget.dataset;
          if (update === "true") {
            // e.currentTarget.htmlFor = id + "_" + name + "_M_" + "U";
            e.currentTarget.htmlFor = `${id}_${name}_M_U`;
            const prev = e.currentTarget.previousSibling as HTMLInputElement;
            // prev.id = id + "_" + name + "_M_" + "U";
            prev.id = `${id}_${name}_M_U`;
            prev.setAttribute("data-type", "U");
          }
        }}
      >
        {label}
      </label>
    </>
  );
}
